import { Meeting } from "@kalyzee/kast-web-sdk/websocket";
import React, { ForwardedRef } from "react";

import { MeetingSessionOvenMediaReceiverManagerBaseData } from "@kalyzee/kast-web-sdk";
import { OvenMediaReceiverWebRTCSession } from "@kalyzee/kast-web-sdk/webrtc";
import { SecondaryScreenSessions } from "../../../../components/secondary-screens/sessions/Sessions";
import { ScreenParams } from "../../../../hooks/screen";
import { SlaveCarouselData } from "../meeting";

export interface SecondaryScreenXProps {
  meeting: Meeting;
  videoSessions: OvenMediaReceiverWebRTCSession<MeetingSessionOvenMediaReceiverManagerBaseData<any>>[];
  screenParams: ScreenParams;
  carouselData: SlaveCarouselData;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export interface SecondaryScreenXRef {}

export const SecondaryScreenX = React.forwardRef(
  (
    { meeting, videoSessions, screenParams, carouselData, children, className, style }: SecondaryScreenXProps,
    forwardRef: ForwardedRef<SecondaryScreenXRef>
  ) => {
    // ---------------------------------------------------------------------- //
    // ---------------------------  EFFECTS ----------------------------- //
    // ---------------------------------------------------------------------- //

    // ---------------------------------------------------------------------- //
    // ---------------------------  RENDER ----------------------------- //
    // ---------------------------------------------------------------------- //

    const classes = [];
    if (className) classes.push(className);
    return (
      <div className={classes.join(" ")} style={style}>
        <SecondaryScreenSessions meeting={meeting} videoSessions={videoSessions} screenParams={screenParams} carouselData={carouselData} />
        {children}
      </div>
    );
  }
);
